//----------------------------------------
// utility-bar.js
//----------------------------------------

$(window).on('scroll', throttle(utilityBar, 100))

function utilityBar(){
    const utilityBar = $('.utility-bar');
    const topOfToolSections = $('#top-of-sections').offset().top;

    function toggle(){
        var currentScrollPos = $(window).scrollTop();

        if(currentScrollPos > topOfToolSections){
            utilityBar.addClass('is-active');
        } else {
            if(utilityBar.hasClass('is-active')){
                utilityBar.removeClass('is-active');
            }
        }
    }

    return toggle();
}
